import { render } from "./ComplianceEvidenceList.vue?vue&type=template&id=194b6a40&scoped=true"
import script from "./ComplianceEvidenceList.vue?vue&type=script&lang=js"
export * from "./ComplianceEvidenceList.vue?vue&type=script&lang=js"

import "./ComplianceEvidenceList.vue?vue&type=style&index=0&id=194b6a40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194b6a40"]])

export default __exports__